import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { UserStatsBundle } from '../../models/statistics';
import { UserService } from '../user.service';

@Injectable({
  providedIn: 'root',
})
export class StatisticsResolverService  {
  constructor(private _userService: UserService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserStatsBundle> {
    return this._userService.getStatsBundle();
  }
}
